import { render, staticRenderFns } from "./DesktopPage.vue?vue&type=template&id=2a25c58e&scoped=true"
import script from "./DesktopPage.vue?vue&type=script&lang=js"
export * from "./DesktopPage.vue?vue&type=script&lang=js"
import style0 from "./DesktopPage.vue?vue&type=style&index=0&id=2a25c58e&prod&lang=scss&scoped=true"
import style1 from "./DesktopPage.vue?vue&type=style&index=1&id=2a25c58e&prod&scoped=true&lang=css"
import style2 from "./DesktopPage.vue?vue&type=style&index=2&id=2a25c58e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a25c58e",
  null
  
)

export default component.exports